"use client";

import React from "react";
import { CarFront, CalendarDays, ThumbsUp, Headset } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const statsData = [{
  id: 1,
  value: "120M+",
  label: "Spendenvolumen (CHF)",
  icon: CarFront
}, {
  id: 2,
  value: "45%",
  label: "Jährliches Wachstum",
  icon: CalendarDays
}, {
  id: 3,
  value: "100%",
  label: "Transparenz-Rate",
  icon: ThumbsUp
}, {
  id: 4,
  value: "24/7",
  label: "Blockchain-Monitoring",
  icon: Headset
}];
function StatCard({
  stat,
  index
}: {
  stat: typeof statsData[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <div ref={ref} data-index={index} className={`flex flex-col items-center justify-center p-6 text-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
    transitionDelay: `${index * 150}ms`
  }}>
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 text-primary ring-1 ring-primary/20 backdrop-blur-sm">
        <stat.icon className="h-8 w-8" />
      </div>
      <h3 className="font-default text-5xl font-bold tracking-tighter text-foreground md:text-6xl lg:text-7xl">
        {stat.value}
      </h3>
      <p className="mt-3 text-sm font-default font-semibold uppercase tracking-widest text-muted-foreground md:text-base">
        {stat.label}
      </p>
    </div>;
}
export default function OurAchievements() {
  return <section data-section-id="223594" id="aktuelle-trends-zahlen" className="relative overflow-hidden bg-background py-20 text-foreground lg:py-32">
      {}
      <div className="pointer-events-none absolute left-1/2 top-1/2 -z-10 h-[300px] w-[600px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-primary/5 blur-[120px] lg:h-[400px] lg:w-[800px]" />

      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          {statsData.map((stat, i) => <StatCard key={stat.id} stat={stat} index={i} />)}
        </div>
      </div>
    </section>;
}